import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getRolesListUrl = (companyId) => `/companies/${companyId}/roles/list`;

const getRolesUrl = (companyId) => `/companies/${companyId}/roles`;

const addRoleUrl = (companyId) => `/companies/${companyId}/roles`;

const getByIdUrl = (companyId, userId) => `/companies/${companyId}/roles/${userId}`;

const updateRoleUrl = (companyId, userId) => `/companies/${companyId}/roles/${userId}`;

const toggleRoleUrl = (companyId, userId) => `/companies/${companyId}/roles/${userId}/toggle`;

const getPermissionsList = (companyId) => `companies/${companyId}/roles/permissions`;

const getPermissionsListAll = (companyId) => `companies/${companyId}/roles/permissions_all`;

const service = {
  configure(endpoint, auth, defaultHeaders) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });
    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  getRolesList(companyId) {
    const url = getRolesListUrl(companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getRoles(companyId, filters, limit, page, orderBy, order) {
    const url = getRolesUrl(companyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getRoleById(companyId, userId) {
    const url = getByIdUrl(companyId, userId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  addRole(companyId, data) {
    const url = addRoleUrl(companyId);
    return this.axios
      .post(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  updateRole(companyId, userId, data) {
    const url = updateRoleUrl(companyId, userId);
    return this.axios
      .put(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggleRole(companyId, userId) {
    const url = toggleRoleUrl(companyId, userId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getPermissionsList(companyId) {
    const url = getPermissionsList(companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
  getPermissionsListAll(companyId) {
    const url = getPermissionsListAll(companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/roles.api.js